import { Root as root } from './root'
import { BottomSheet as bottomSheet } from './bottomSheet'
import { Actions as actions } from './actions'
import { Price as price } from './price'
import { Buttons as button } from './button'

export const SummaryMobile = {
  root,
  bottomSheet,
  actions,
  price,
  button
}
